<template>
    <div class="mt-32 ml-16 mx-auto flexmobile2">
      <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">User Personas & Journey Maps</h1>
    <main class="flex flexmobile2  md:mt-24 ml-5 px-20 gap-10 max-md:flex-col">
     
      <section class="flex  flexmobile2flex-col  max-md:ml-0 max-md:w-full">
        <div class="flex flexmobile2 flex-col w-full max-md:max-w-full">
          <div class="max-md:max-w-full">
            <div class="flex flexmobile2 gap-28 max-md:flex-col">
                <!-- left side -->
              <div class="flex flexmobile2 flex-col w-1/2 max-md:ml-0 max-md:w-full -ml-20">
                <div class="flex flex-col grow items-center max-md:mt-10 max-md:max-w-full">
                  <figure class="flex flexmobile2  relative flex-col justify-center p-20 ml-3.5 max-w-full md:min-h-[484px] w-[484px] max-md:px-5">
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/834c7a13962fe5493762196d323202d9b7de0248a4cf0e7a2ad210383ecaff32?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="" class="object-cover flexmobile2 absolute inset-0  md:size-full" />
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/27b16a81d8b441c80e5b45ec23c5d5e96f54f4f38e5ef22a658b92199a6ace29?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Stella Maxwell" class="object-contain flexmobile2 md:w-full md:aspect-square" />
                  </figure>
                  <h1 class=" md:mt-11 mb-11  ml-10 md:text-5xl font-semibold text-white max-md:mt-10 max-md:max-w-full max-md:text-4xl text-purple-300">
                    STELLA MAXWELL
                  </h1>
                  <p class="font-medium text-center text-amber-50 max-md:max-w-full">
                    MARKETING EXECUTIVE
                  </p>
                  <div class="flex flexmobile2 flex-col text-2xl max-md:mt-10 max-md:max-w-full mt-12">
                  <h2 class="self-start font-bold text-purple-300 mt-8">BIOGRAPHY</h2>
                  <p class="mt-5 text-lg text-amber-50 max-md:max-w-full">
                    Stella is a budget-conscious consumer who takes her family's financial management seriously. She recognizes the value of cost-effective solutions and expense optimization as a marketing executive. Stella, who is married and has a baby boy. It is essential for her to establish a budget and closely monitor expenses to uphold financial stability. Stella actively looks for methods to cut costs without sacrificing her family's standard of living.
                  </p>
                </div>
                </div>
              </div>
              <!-- end of left  -->
              <div class="flex flex-col  -mt-8 max-md:ml-0 max-md:w-full">
                <div class="flex flex-col md:mt-20 w-full text-2xl font-semibold text-amber-50 max-md:max-w-full">
                  <div class="flex text-lg mb-16  flex-wrap gap-4 text-center max-md:max-w-full">
                    <p>AGE : 28</p>
                    <p class="grow">GENDER : WOMAN</p>
                    <p class="grow ">
                      FAMILY : MARRIED WITH A CHILD
                    </p>
                  </div>
                  <div class="flex flexmobile2 mb-16 relative  flex-col   max-md:ml-0 max-md:w-full">
        <div class="z-10 dancing-script md:text-3xl font-semibold text-purple-300 rounded-none max-md:pr-0 max-md:max-w-full">
          "I believe in making smart financial choices without sacrificing the things my family enjoys. Finding affordable alternatives is the key to maintaining a healthy budget."
        </div>
      </div>
                  <h2 class="self-start  text-purple-300 max-md:mt-10">GOALS</h2>
                  <ol class="mt-5 list-disc text-lg mr-8 font-medium max-md:mr-2.5 max-md:max-w-full">
                    <li class="mt-4">Find ways to cut down on unnecessary expenses and save more for her family's future.</li>
                    <li class="mt-4">Lookout for cost-effective options.</li>
                    <li class="mt-4">Have a clear overview of all active subscriptions</li>
                    <li class="mt-4">Needs notifications about upgrades and an estimate of monthly spending.</li>
                    <li class="mt-4">Recommendations that can help make informed choices when it comes to subscribing to new services or renewing existing ones.</li>
                  </ol>
                  <div class="flex flex-col mt-24 max-md:ml-0 max-md:w-full">
                <div class="flex flex-col grow text-2xl max-md:mt-10 max-md:max-w-full">
                  <h2 class="self-start font-bold text-purple-300">PAIN POINTS</h2>
                  <ol class="mt-5 list-disc text-lg font-medium text-amber-50 max-md:max-w-full">
                    <li class="mt-4">Concerned about overspending and wanting to avoid unnecessary expenses.</li>
                    <li class="mt-4">Managing multiple subscriptions for her family can be overwhelming, and she needs a system or tool to keep everything organized.</li>
                    <li class="mt-4">Feels the need for more granular information about expenses to identify areas where they can save money.</li>
                    <li class="mt-4">Requires better tools that analyze spending patterns and notifies her regularly.</li>
                  </ol>
                </div>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
    </main>
    </div>

    <!-- secound section  -->
     <div class="md:mt-44 flexmobile  mx-auto px-20">
        <h2 class=" text-center lavender-color text-3xl font-semibold mb-10">STELLA’S JOURNEY</h2>
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677880/Group_1939_1_kkb0mx.png" alt="">
     </div>
     <!-- section three -->
     <div class="md:mt-32">
    <main class="flex flexmobile2  md:mt-24  mx-auto px-20 gap-10 max-md:flex-col">
      <section class="flex flexmobile2 flex-col  max-md:ml-0 max-md:w-full">
        <div class="flex flexmobile2 flex-col w-full max-md:max-w-full">
          <div class="max-md:max-w-full">
            <div class="flex gap-24 max-md:flex-col">
                <!-- left side -->
              <div class="flex flexmobile2 flex-col w-1/2 max-md:ml-0 max-md:w-full">
                <div class="flex flexmobile2 flex-col grow items-center max-md:mt-10 max-md:max-w-full">
                  <figure class="flex flexmobile2 relative flex-col justify-center p-20 ml-3.5 max-w-full md:min-h-[484px] w-[484px] max-md:px-5">
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/9ee54974cd45525454c7a8971db90448c95bdb42e541e53fcacf3e6d388462a3?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="" class="object-cover flexmobile2 absolute inset-0 md:size-full" />
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/8b2700ca0356362141c108aac9adf4f93cfe1948b96ccf1f7b200a40ec6b7119?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Portrait of David Hamilton" class="object-contain flexmobile2 md:w-full aspect-square" />
                </figure>
                  <h1 class=" md:mt-11 mb-11  ml-10 md:text-5xl font-semibold text-white max-md:mt-10 max-md:max-w-full max-md:text-4xl text-purple-300">
                    DAVID HAMILTON
                  </h1>
                  <p class=" font-medium text-center text-amber-50 max-md:max-w-full -mt-8">
                    SR. PROJECT MANAGER
                  </p>
                  <div class="flex flex-col text-2xl max-md:mt-10 max-md:max-w-full mt-12">
                  <h2 class="self-start font-bold text-purple-300 mt-8">BIOGRAPHY</h2>
                  <p class="mt-5 text-lg text-amber-50 max-md:max-w-full">
                    David is a busy professional who leads a demanding work life. As a senior project manager, he is responsible for overseeing multiple projects and teams. He relies heavily on technology to stay organized and is open to exploring new tools that can help streamline his professional and personal life. He is comfortable with technology and appreciates a seamless user experience. With limited time available, David seeks solutions that can simplify his tasks and provide quick and accurate information.                  </p>
                </div>
                </div>
              </div>
              <!-- end of left  -->
              <div class="flex flex-col ml-5  max-md:ml-0 max-md:w-full">
                <div class="flex flexmobile2 flex-col md:mt-20 w-full text-2xl font-semibold text-amber-50 max-md:mt-10 max-md:max-w-full">
                  <div class="flex text-lg mb-16 flex-wrap gap-4 text-center max-md:max-w-full">
                    <p>AGE : 29</p>
                    <p class="grow ">GENDER : MALE</p>
                    <p class="grow ">
                        FAMILY : BACHELOR, LIVES ALONE
                    </p>
                  </div>
                  <div class="flex flexmobile2 mb-16 flex-col   max-md:ml-0 max-md:w-full">
        <blockquote class="z-10 dancing-script md:text-3xl font-semibold text-purple-300 rounded-none max-md:pr-0 max-md:max-w-full">
            "I need tools that can keep up with my fast-paced life. Streamlining tasks, staying on top of my subscriptions, and maximizing productivity is crucial for maintaining efficiency."        </blockquote>
      </div>
                    
                  <h2 class="self-start  text-purple-300 max-md:mt-14">GOALS</h2>
                  <ol class="mt-5 list-disc text-lg mr-8 font-medium max-md:mr-2.5 max-md:max-w-full">
                    <li class="mt-4">Simplify the process of canceling subscriptions, making it quick and hassle-free.</li>
                    <li class="mt-4">Ensure he doesn't miss out on new technology tools or apps that can enhance thei productivity and efficiency.</li>
                    <li class="mt-4">Maintain a clear overview of their subscription spending for accounting purposes and streamline business expenses.</li>
                        </ol>
                  <div class="flex flex-col mt-24 max-md:ml-0 max-md:w-full">
                <div class="flex flex-col grow text-2xl max-md:mt-10 max-md:max-w-full">
                  <h2 class="self-start font-bold text-purple-300">PAIN POINTS</h2>
                  <ol class="mt-5 list-disc text-lg font-medium text-amber-50 max-md:max-w-full">
                    <li class="mt-4">Finds it challenging to devote time to manually analyze their subscription expenses due to their busy schedule.</li>
                    <li class="mt-4">Faces difficulties in canceling subscriptions, especially when the cancellation processes are complex or time-consuming.</li>
                    <li class="mt-4">With limited time for research, fears missing out on new technology tools or apps that can improve his productivity.</li>
                    <li class="mt-4">Wants to ensure that their business expenses are well-managed and optimized but faces challenges in maintaining a clear overview of subscription spending for accounting purposes.</li>
                  </ol>
                </div>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
    </main>
    </div>
   <!-- section four -->
   <div class="mt-44 flexmobile2  mx-auto px-20">
        <h2 class=" text-center lavender-color text-3xl font-semibold mb-10">DAVID’S JOURNEY</h2>
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726677980/Group_1940_sak1py.png" alt="">
     </div>
     <!-- section five -->
      <div class=" flexmobile2 mt-8 mx-auto px-20">
        <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Recommendations</h1>
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726678008/Group_1887_may3vt.png" alt="">
      </div>

      <!-- section six -->
       <div class=" mx-auto flexmobile mt-44  px-20" >
        <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Limitations</h1>
        <ul class="text-white pt-6 text-lg md:pb-6">
            <li class="text-white pt-6 text-lg  text-white">Include people over the age of 30</li>
            <li class="text-white pt-6 text-lg  text-white">Include people that share subscriptions</li>
            <li class="text-white pt-6 text-lg  text-white">Include people in novel phases of life.</li>
        </ul>
       </div>
       <div class=" mx-auto flexmobile  mt-44  px-20">
        <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Future Work</h1>
        <p class="pt-6 text-lg md:pb-6 text-white">Further studies can include interviews to explore how people share subscriptions and how subscription usage changes over different life phases and household structures.</p>
       </div>

       <!-- subscribtion fotter  -->
       <div class="flex flexmobile2 justify-center">
        <div class=" md:w-6xl flexmobile2 mt-24 flex justify-self-center">
        <a
            href="https://online.fliphtml5.com/kqzee/ohzy/#p=1"
              class="flex   relative p-10  bgColorr  top-2 md:mt-24  md:w-46 h-12 text-center text-xl rounded-[80px] shadow-[0px_4px_24px_rgba(0,0,0,0.5)]"
            >
              <span class="grow text-white relative bottom-4 text-center ">Access Project Report</span>
            </a>
      </div>
       </div>
       <section class="flex flexmobile md:mb-44 px-20 mx-auto container relative md:top-60 justify-center flex-col flex-wrap mt max-md:mt-10">
        <h2 class="text-4xl text-center font-semibold text-white">View other Projects</h2>
        <div class="self-start mt-2 ml-4 max-md:max-w-full">
          <div class="flex justify-center  gap-5 max-md:flex-col">
            <article class="flex md:mb-8 w-full max-md:ml-0 max-md:w-full">
              <div class="flex justify-between items-start font-bold text-white rounded-[50px] max-md:px-5 max-md:mt-10 max-md:flex-col max-md:items-center max-md:space-y-5">
    <router-link to="LorealProject">
        <div class="cursor-pointer relative z-10 w-full max-w-full">
            <img loading="lazy" class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726678058/Group_34203_wce8yw.png" alt="">
        </div>
    </router-link>
    <router-link to="WangosProject">
        <div class="cursor-pointer relative z-10 ">
          <img loading="lazy" class="w-full md:mb-8" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726678071/Group_34202_jsapnl.png" alt="">
        </div>
    </router-link>
</div>
            </article>
          </div>
        </div>
      </section>
  </template>

     
 
  <script>
  export default {
    name: 'SubscreptionFotterSec'
  }
  </script>
